<ng-container *ngIf="type === SearchType.Page">
    <adapt-search-row-page *ngFor="let result of searchResults.Page"
                           [result]="result"></adapt-search-row-page>
</ng-container>
<ng-container *ngIf="type === SearchType.PersonTeamRole">
    <ng-container *ngFor="let result of searchResults.PersonTeamRole">
        <adapt-search-row-person *ngIf="SearchService.isPerson(result) as person"
                                 [result]="person"></adapt-search-row-person>
        <adapt-search-row-role *ngIf="SearchService.isRole(result) as role"
                               [result]="role"></adapt-search-row-role>
        <adapt-search-row-team *ngIf="SearchService.isTeam(result) as team"
                               [result]="team"></adapt-search-row-team>
    </ng-container>
</ng-container>
<ng-container *ngIf="type === SearchType.Kanban">
    <adapt-search-row-kanban *ngFor="let result of searchResults.Kanban"
                             [result]="result"></adapt-search-row-kanban>
</ng-container>
<ng-container *ngIf="type === SearchType.Meeting">
    <adapt-search-row-meeting *ngFor="let result of searchResults.Meeting"
                              [result]="result"></adapt-search-row-meeting>
</ng-container>
<ng-container *ngIf="type === SearchType.Objective">
    <adapt-search-row-objective *ngFor="let result of sortedObjectiveResults"
                                [result]="$any(result)"></adapt-search-row-objective>
</ng-container>
<ng-container *ngIf="type === SearchType.System">
    <adapt-search-row-system *ngFor="let result of searchResults.System"
                             [result]="result"></adapt-search-row-system>
</ng-container>
<ng-container *ngIf="type === SearchType.Tier1">
    <ng-container *ngFor="let result of sortedTier1Results">
        <adapt-search-row-value-stream *ngIf="SearchService.isValueStream(result) as vs"
                                       [result]="vs"></adapt-search-row-value-stream>
        <adapt-search-row-key-function *ngIf="SearchService.isKeyFunction(result) as kf"
                                       [result]="kf"></adapt-search-row-key-function>
        <adapt-search-row-product *ngIf="SearchService.isProduct(result) as product"
                                  [result]="product"></adapt-search-row-product>
    </ng-container>
</ng-container>
<ng-container *ngIf="type === SearchType.Guidance">
    <ng-container *ngFor="let result of sortedGuidanceResults">
        <adapt-search-row-purpose-vision *ngIf="SearchService.isPurposeVision(result) as purposeVision"
                                         [result]="purposeVision"></adapt-search-row-purpose-vision>
        <adapt-search-row-value *ngIf="SearchService.isValue(result) as value"
                                [result]="value"></adapt-search-row-value>
        <adapt-search-row-resilient-business-goal *ngIf="SearchService.isResilientBusinessGoal(result) as rbg"
                                                  [result]="rbg"></adapt-search-row-resilient-business-goal>
        <adapt-search-row-strategic-theme *ngIf="SearchService.isStrategicTheme(result) as theme"
                                          [result]="theme"></adapt-search-row-strategic-theme>
        <adapt-search-row-strategic-goal *ngIf="SearchService.isStrategicGoal(result) as goal"
                                         [result]="goal"></adapt-search-row-strategic-goal>
        <adapt-search-row-strategic-anchor *ngIf="SearchService.isStrategicAnchor(result) as anchor"
                                           [result]="anchor"></adapt-search-row-strategic-anchor>
        <adapt-search-row-competitor-analysis *ngIf="SearchService.isCompetitorAnalysis(result) as ca"
                                              [result]="ca"></adapt-search-row-competitor-analysis>
        <adapt-search-row-bullseye *ngIf="SearchService.isBullseye(result) as bullseye"
                                   [result]="bullseye"></adapt-search-row-bullseye>
    </ng-container>
</ng-container>
